import {makeStyles} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: '#336699', // change to theme color
    fontSize: 18,
    position: 'relative',
  },
  container: {
    paddingLeft: '40px',
    paddingRight: '30px',
  },
  breadcrumbLink: {
    fontSize: 16,
    padding: '5.5px 0',
    color: theme.palette.common.white,
    '&:hover': {
      color: theme.palette.common.white,
    },
  },
}))

export default useStyles
